import React from 'react';
import { Form, Input } from 'antd';
import "./shared.css";

const FormTitleInput = ({ value, onChange, className, variant, name }) => {

  const defaultTitle = "Formulaire sans titre"

  return (
    // <Form.Item > 
      <Input  name={name} 
        placeholder='Titre du formulaire'
        variant={variant}
        value={ value || defaultTitle }
        onChange={onChange}
       className={className} 
      />
      // </Form.Item>
 
  );
};
 
export default FormTitleInput;
